import moment from 'moment';
import VueSnotify, {SnotifyPosition} from "vue-snotify";

let Notify = [];
Notify.install = function(Vue, options){
    Vue.use(VueSnotify, {
        toast: {
            position:SnotifyPosition.rightTop,
            closeOnClick:true,
        }
    })
    Vue.prototype.$notify ={
        warningConfirm: (title,func,options) => {
            let defaultOptions = {
                position:SnotifyPosition.centerCenter,
                buttons: [
                    {text: 'Yes', action: (toast) => {func();Vue.prototype.$snotify.remove(toast.id);}, bold: false},
                    {text: 'No', action: (toast) => Vue.prototype.$snotify.remove(toast.id)},
                ],
                backdrop:0.5,
                timeout:0,
                closeOnClick: true
            }
            if(options) $.extend(defaultOptions,options)
            Vue.prototype.$snotify.warning('Do you want to Delete?',title,defaultOptions)
        },
        success: (title,body) => {
            let defaultOptions = {
                backdrop:0.5,
                timeout:200,
            }
            Vue.prototype.$snotify.success(body?body:'',title,defaultOptions)
        },
        error: (title,body) => {
            Vue.prototype.$snotify.error(body?body:'',title)
        },
        alert: (body,options) => {
            let defaultOptions = {
                position:SnotifyPosition.centerCenter,
                backdrop:0.5,
                timeout:0,
                closeOnClick: true,
                buttons: [
                    {text: 'Close', action: (toast) => {Vue.prototype.$snotify.remove(toast.id); }, bold: true},
                ],
            }
            if(options) $.extend(defaultOptions,options)
            Vue.prototype.$snotify.warning(body?body:'','Alert',defaultOptions)
        },
    }
};

export default Notify;
